import React from 'react';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { formatAsPositivePoundsOrPence } from 'utils/currency';
import { getTotalEstimatedCost } from 'redux/modules/trolley/selectors/get-totals';
import { getTotalNumberOfItems } from 'redux/modules/trolley/selectors/number-of-items';
import getIsTrolleyInitialLoading from 'redux/modules/trolley/selectors/get-loading-customer-info';
import { useWtrSelector } from 'redux/hooks';
import classNames from 'classnames';
import { useMinSpend } from 'hooks/use-min-spend';
import GoToTrolley from './GoToTrolley';
import TrolleyButtonContents from './TrolleyButtonContents';

import styles from './ShoppingSummary.scss';

const ShoppingSummary = () => {
  const initialLoading = useWtrSelector(getIsTrolleyInitialLoading);
  const loadingAdd = useWtrSelector(state => state.trolley.loadingAdd);
  const totalEstimatedCost = useWtrSelector(getTotalEstimatedCost);
  const totalNumberOfItems = useWtrSelector(getTotalNumberOfItems);
  const loadingStatus = initialLoading || loadingAdd;
  const { showMinSpend, minSpend } = useMinSpend();

  const estimatedCost = formatAsPositivePoundsOrPence(totalEstimatedCost);
  const description = `trolley, ${totalNumberOfItems} item${
    totalNumberOfItems !== 1 ? 's' : ''
  } ${estimatedCost} total, view trolley.`;

  return (
    <div className={styles.shoppingSummary}>
      <section
        className={styles.trolleyActions}
        data-actiontype="redirect"
        data-customdata="category:Header"
        data-origincomponent="ShoppingSummary"
        data-shortdescription={description}
      >
        <GoToTrolley
          className={styles.trolleyLink}
          data-testid="header-trolley-link"
          originComponent="site-header accessible trolley link"
          title={description}
          totalNumberOfItems={totalNumberOfItems}
        >
          <TrolleyButtonContents
            estimatedCost={estimatedCost}
            loadingStatus={loadingStatus}
            showMinSpend={showMinSpend}
          />
        </GoToTrolley>
        <div
          className={classNames(styles.minSpendWrap, {
            [styles.show]: showMinSpend,
            [styles.hide]: !showMinSpend,
          })}
        >
          <Typography styleAs="paragraphExtraSmall" textStyle="body-xs">
            Min. <span className="sr-only">order</span> £{minSpend}
          </Typography>
        </div>
      </section>
    </div>
  );
};

export default ShoppingSummary;
